import { Injectable, Output, EventEmitter, Directive, inject } from '@angular/core';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { PlanBasicInfo } from '../../../models/plan-basicinfo.model';

import { AppConfig } from '../../../../app.config';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class PlanBasicinfoService {

    private readonly config = inject(AppConfig);

    private urlIwmBackend: string = this.config.backendIwmUri + 'PlanApi/';

    public streamSubscription: Subscription = new Subscription();

    // Define new planChanged custom event
    @Output()
    planChanged: EventEmitter<string> = new EventEmitter<string>();


    // Current plan basic information object as subscribable stream
    public planBasicInformation$ = new BehaviorSubject<PlanBasicInfo>({} as PlanBasicInfo);

    constructor(private http: HttpClient) { }


    /**
      * Get plan details by GUID
      * @param {string} id GUID plan identifier
      * @returns {Observable<PlanBasicInfo>}
      */
    public getPlanBasicinfo(id: string/*, idGuard: boolean = false*/): Observable<PlanBasicInfo> {
        const url = this.urlIwmBackend + `Plans(${id})`;
        const plan = this.http.get<PlanBasicInfo>(url);
        return plan;
    }

    /**
     * Get plan details by iwmId
     * @param {number} iwmId numeric plan identifier
     * @returns {Observable<PlanBasicInfo>}
     */
    public getPlanBasicInfoByIwmId(iwmId: number): Observable<PlanBasicInfo> {
        const url = this.urlIwmBackend + `Plans?$filter=IwmId eq ${iwmId}`;
        const data = this.http.get<PlanBasicInfo>(url);
        return data;
    }

    /**
      * Update plan basicinformation
      * @param {string} planId Id of the plan
      * @param {PlanBasicInfo} planBasicInfo PlanBasicInfo object
      * @returns {Observable<boolean>}
      */
    public patch(planId: string, basicInfo: PlanBasicInfo): Observable<any> {
        const url = this.urlIwmBackend + `Plans(${planId})`;
        return this.http.patch(url, basicInfo);
    }
}
